export enum ApiActionType {
    Added       = 'Added',
    Modified    = 'Modified',
    Deleted     = 'Deleted',
}